const replaceElementInArrayByIndex = (array: any[], replaceElement: any, index: number) => {
    return array.map((el, elIndex) => {
        if (elIndex === index) {
            return replaceElement
        }
        return el
    })
}

const toBase64 = (file): Promise<string | ArrayBuffer> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.toString().replace(/^.*,/, ""))
        reader.onerror = error => reject(error)
    })

const includesTranslation = (name: string) =>
    [
        "title",
        "content",
        "question",
        "summary",
        "short_summary",
        "summary_subtitle",
        "response",
        "free_response_prompt",
        "not_applicable_label",
        "not_applicable_prompt",
        "subtitle",
        "assignment_description",
        "typing_prompt"
    ].includes(name)

function shallowEqual(obj1: any, obj2: any): boolean {
    if (typeof obj1 !== typeof obj2) {
        return false
    }

    const keys1 = Object.keys(obj1)
    const keys2 = Object.keys(obj2)

    if (keys1.length !== keys2.length) {
        return false
    }

    for (const key of keys1) {
        if (typeof obj1[key] === "object" || typeof obj2[key] === "object") {
            continue
        }

        if (obj1[key] !== obj2[key]) {
            return false
        }
    }

    return true
}

export { replaceElementInArrayByIndex, toBase64, includesTranslation, shallowEqual }
